export default "__VITE_ASSET__9mvJJBsI__"